import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon, grey600 } from '@paypalcorp/pp-react';

function SocialShareWhatsapp({ url, handleSocialLinkClick }) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'whatsapp')}
      style={{ color: grey600 }}
    >
      <Icon name="share-whatsapp" size="lg" />
    </Link>
  );
}

SocialShareWhatsapp.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
};

export default SocialShareWhatsapp;
